import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FISH_TYPE } from "../../varibles/constants";
import { IDisease, IFishGroup, ISite } from "../../varibles/interface";
import { initialState, NAME_SLICE } from "./constants";

const siteSlice = createSlice({
    name: NAME_SLICE,
    initialState,
    reducers: {
        gets: (state) => {
            state.loading = true;
            state.data = [];
        },
        getsSuccess: (state, action: PayloadAction<ISite[]>) => {
            state.loading = false;
            state.data = action.payload;
        },
        getsFailure: (state) => {
            state.loading = false;
        },
        getOverview: (state, _: PayloadAction<string | undefined>) => {
            state.overview.loading = true;
        },
        getOverviewSuccess: (state, action: PayloadAction<ISite[]>) => {
            const proAreas: string[] = [];
            const diseases: { [id: string]: IDisease } = {};
            const amount: { [id: string]: number } = {};
            state.overview.data = action.payload.reduce((rs: typeof state.overview.data, site) => {
                if (site.site_type === FISH_TYPE.SMOLT)
                    return rs;

                if (site.prod_area)
                    proAreas.push(site.prod_area);
                amount[site.id] = 0;
                return [...rs, ...site.units.map(unit => {
                    amount[site.id] += unit.fish_amount;
                    if (unit.unit_diseases) {
                        unit.unit_diseases.types.forEach(item => diseases[item.id] = item)
                    }
                    return { ...unit, site }
                })];
            }, []);
            state.overview.loading = false;
            state.overview.proAreas = new Set(proAreas);
            state.overview.diseases = diseases;
            state.overview.amount = amount;
        },
        getOverviewFailure: (state) => {
            state.overview.loading = false;
        },
        updateDashboard: (state, action: PayloadAction<ISite[]>) => {
            state.dashboard = action.payload;
        },
        getFishGroup: (state) => {
            state.fishGroup.loading = true;
        },
        getFishGroupSuccess: (state, action: PayloadAction<IFishGroup[]>) => {
            state.fishGroup.loading = false;
            state.fishGroup.data = action.payload;
        },
        getFishGroupFailure: (state) => {
            state.fishGroup.loading = false;
        },
        add: (state, action) => {
            const site = action.payload;
            const { data } = state;
            state.data = [...data, site];
        },
        update: (state, action) => {
            const site = action.payload;
            const { data } = state;
            state.data = data.map(item => item.id === site.id ? site : item)
        },
        delete: (state, action) => {
            const id = action.payload;
            const { data } = state;
            state.data = data.filter(item => item.id !== id);
        },
    },
})

export const siteActions = siteSlice.actions

const siteReducer = siteSlice.reducer;

export default siteReducer;
